<div class="w-full">
  <div class="survey-question-wrapper">
    {{surveyQuestions?.title ? surveyQuestions?.title : surveyQuestions?.name}}
  </div>
  <div *ngIf="surveyQuestions.inputType !== 'url' && surveyQuestions.inputType !== 'color'"
       class="survey-answer-wrapper">
    {{surveyQuestions?.choices ? value : surveyQuestions?.value}}
  </div>
  <div *ngIf="surveyQuestions.inputType === 'url'"
       class="survey-answer-wrapper">
    <a [href]="surveyQuestions?.value"
       class="clickable"
       target="_blank">{{surveyQuestions?.value}}</a>
  </div>
  <div *ngIf="surveyQuestions.inputType === 'color'"
       class="survey-answer-wrapper">
    <div class="survey-color-answer w-[20%]" [ngStyle]="{backgroundColor:surveyQuestions?.value}"> 

    </div>
  </div>
</div>
